function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  strokeWidth: 2.458,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M2.15 1.229a.922.922 0 0 0-.92.995l.624 7.833c.038.48.438.849.919.849h10.583c.48 0 .88-.37.919-.849l.623-7.833a.922.922 0 0 0-.918-.995H2.15zM21.567 1.229a.922.922 0 0 0-.919.995l.624 7.833c.038.48.438.849.918.849h10.584c.48 0 .88-.37.918-.849l.624-7.833a.922.922 0 0 0-.919-.995h-11.83zM15.862 2.302h3.661v2.072h-3.661z"
}));

var SvgGlasses = function SvgGlasses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 36 13",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glasses.43befe50.svg";
export { ForwardRef as ReactComponent };